import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiError } from '@cms_root/app/core/models/api-error.model';

@Component({
  selector: 'app-access-denied-page',
  templateUrl: './access-denied-page.component.html',
  styleUrls: ['./access-denied-page.component.scss'],
  standalone: false
})
export class AccessDeniedPageComponent {
  public message: string;

  constructor(private readonly router: Router) {
    const routeData = this.router.getCurrentNavigation().extras.state as { error: ApiError };
    this.message = routeData?.error?.details?.exceptionMessage;
  }
}
